import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import {Button, Card, Col, Form, Input, QRCode, Row, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiAlarm, BiAlarmOff, BiPencil, BiPlus, BiQr, BiRefresh, BiTrash, BiWorld} from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import dayjs, {Dayjs} from 'dayjs';
import {User} from "../../model/root/User";
import {GetUsuaris} from "../../dao/root/GetUsuaris";
import ControlHorari from "../../model/root/ControlHorari";
import controlHorari from "../../model/root/ControlHorari";
import {GetControlHorari} from "../../dao/root/GetControlHorari";
import ControlHorariModal from "./component/ControlHorariModal";
import {PostControlHorari} from "../../dao/root/PostControlHorari";
import {format} from "date-fns";
import QrModal from "./component/QrModal";
import LlocTreball from "../../model/root/LlocTreball";
import {GetLlocTreball} from "../../dao/root/GetLlocTreball";
import {VscGraph} from "react-icons/vsc";
import LlocDeTreballModal from "./component/LlocDeTreballModal";
import Login from "./Login";
import LlocsTreball from "./LlocsTreball";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {CheckUser} from "../../dao/root/CheckUser";
import toast, {Toaster} from "react-hot-toast";
import {useForm} from "antd/es/form/Form";

const ControlHoraris = () => {
    const titol: string = "Control Horari";
    const nomPermis: string = "Control Horari";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [options, setOptions] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);
    const [options2, setOptions2] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);

    const [coleccio, setDades] = useState<ControlHorari[]>([]);
    const [coleccio2, setDades2] = useState<LlocTreball[]>([]);
    const [usuaris, setUsuaris] = useState<User[]>([]);
    const [elementSelected, setElementSelected] = useState<ControlHorari>(new ControlHorari());
    const [llocSelected, setLlocSelected] = useState<LlocTreball>(new LlocTreball());
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [qrValue, setQrValue] = useState('');
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [visible2, setVisible2] = useState(false);
    const [qrVisible, setQrVisible] = useState(false);
    const [update, setUpdate] = useState(false);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [nouLloc, setNouLloc] = useState(false);
    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);
    const permisVisualitzacio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 0);

    useEffect(() => {
        handleLoadingChange(true)
        if (isLoggedIn) {
            if (permisosEdicio) {
                checkDades();
                checkDades2();
            }
            if (permisVisualitzacio) {

            }
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        setQrValue('');
        await checkDades2();
        const usuaris = await GetUsuaris(page);
        setUsuaris(usuaris.usuaris);
        const dades = await GetControlHorari(page, '');
        console.log(dades);
        setDades(dades);
        setUsuarisOptions(usuaris.usuaris);
        setNameFilters(dades);
        handleLoadingChange(false);
    }

    async function checkDades2() {
        const dades = await GetLlocTreball(page);
        setLlocsOptions(dades);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    function setUsuarisOptions(usuaris: User[]) {
        if (usuaris && usuaris?.length) {
            const options = usuaris.map(contact => ({
                label: `${contact.nom}`,
                value: contact.id + ""
            }));
            setOptions(options);
        }
    }

    function setLlocsOptions(llocs: LlocTreball[]) {
        if (llocs && llocs?.length) {
            const options = llocs.map(lloc => ({
                label: `${lloc.nom}`,
                value: lloc.id + ""
            }));
            setOptions2(options);
        }
    }

    function afegirElement(element: ControlHorari) {
        setNouElement(!nouElement);
        setUpdate(false);
        setElementSelected(element);
    }

    function togleNouElement(element: ControlHorari) {
        setNouElement(!nouElement);
        setUpdate(true);
        const modified: controlHorari = {
            ...element,
            entrada: dayjs(element.entrada),
            sortida: dayjs(element.sortida)
        };
        setElementSelected(modified);
    }

    function desactivarElement(element: ControlHorari) {
        const modified: controlHorari = {
            ...element,
            estat: (element.estat === 0 ? 1 : 0)
        };
        handleCloseModal(modified, true);
    }

    async function deleteElement(element: ControlHorari) {
        const modified: controlHorari = {
            ...element,
            estat: -1
        };
        handleCloseModal(modified, true);
    }

    async function handleCloseModal(element: ControlHorari, guardar: boolean) {
        setNouElement(false);
        if (guardar) {
            setLoading(true);
            await PostControlHorari(element, page);
            await checkDades();
        }
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    const handleLoadingChange2 = (enable: boolean) => {
        setLoading2(enable);
    };

    function setNameFilters(elements: ControlHorari[]) {
        const ControlHorariNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(ControlHorariNames);
    }

    function showEstadistiques(ele: ControlHorari) {
        navigate("/controlhorari/"+ele.id_usuario);
    }

    const columns: ColumnsType<ControlHorari> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'entrada',
            title: 'Entrada',
            dataIndex: 'entrada',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color1}>{ele.entrada+""}</Tag>
            )
        },
        {
            key: 'sortida',
            title: 'Sortida',
            dataIndex: 'sortida',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color2}>{ele.sortida+""}</Tag>
            )
        },
        {
            key: 'lloc',
            title: 'Lloc de treball',
            dataIndex: 'lloc',
            width: 30,
            render: (estat, ele) =>(
                (ele.lloc === 'Itinerant' && <Tag color={Colors.colors.color4}>{ele.lloc}</Tag>) || (ele.lloc !== 'Itinerant' && ele.lloc)
            )

        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 140,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Invalidar"} style={ele.estat === 0 ? {backgroundColor: Colors.colors.color3}
                                : {backgroundColor: Colors.colors.color1}}
                                    onClick={() => desactivarElement(ele)}>{ele.estat === 0 ? <BiAlarmOff/> :
                                <BiAlarm/>}</Button>{" "}
                            <Button title={"Modificar"} style={{backgroundColor: Colors.colors.color4}}
                                    onClick={() => togleNouElement(ele)}><BiPencil/></Button>{" "}
                            <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}
                                    onClick={() => deleteElement(ele)}><BiTrash/></Button>{" "}
                            <Button title={"Estadístiques"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => showEstadistiques(ele)}><VscGraph/></Button>
                        </>
                    )}
                </>
            ),
        },
    ];

    const tableProps: TableProps<ControlHorari> = {
        loading
    };

    const onChange: TableProps<ControlHorari>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    function QRGenerator() {
        setQrVisible(true);
    }

    function handleCloseQr() {
        setQrVisible(false);
    }

    const getFormattedDate = () => {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1; // Los meses en JavaScript son base 0, así que agregamos 1
        const year = today.getFullYear();

        // Asegurémonos de que los valores tengan dos dígitos
        const formattedDay = day < 10 ? `0${day}` : day;
        const formattedMonth = month < 10 ? `0${month}` : month;

        return `${formattedDay}-${formattedMonth}-${year}:${userId}`;
    };

    async function handleLlocModalClose(element: LlocTreball, guardar: boolean) {
        setNouLloc(false);
        if (guardar) {
            setLoading2(true);
            //await PostControlHorari(element, page);
            await checkDades2();
            await checkDades();
        }
    }
    async function deleteLloc(element: LlocTreball) {
        const modified: LlocTreball = {
            ...element,
            estat: -1
        };
        handleLlocModalClose(element, true);
    }

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {permisosEdicio &&
                                <>
                                    <Button hidden={true} title={"Nou Control Horari"} style={{backgroundColor: Colors.colors.color2}}
                                            onClick={() =>
                                                afegirElement(new ControlHorari())}><BiPlus/></Button>
                                    <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                        checkDades()}><BiRefresh/></Button>
                                </>
                            }
                                <Button title={"Mostrar QR"} style={{backgroundColor: Colors.colors.color6}}
                                        onClick={() => QRGenerator()}><BiQr/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && permisosEdicio && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                dataSource={coleccio}
                            />
                        )}
                        { permisVisualitzacio && (
                            <QrModal visible={qrVisible} content={''} onClose={handleCloseQr} />
                        )}
                    </Card>
                    <br/>
                    { permisosEdicio && <LlocsTreball />}
                    <br/>
                    { permisosEdicio && <Historials pantalla={"CONTROLHORARI"} pagina={page}/>}
                    {nouElement && (
                        <ControlHorariModal element={elementSelected} onClose={handleCloseModal}
                                            visible={nouElement} options={options} usuaris={usuaris}
                                            update={update} llocsTreball={options2}/>
                    )}
                    {qrVisible && (
                        <QrModal visible={qrVisible} onClose={handleCloseQr} content={getFormattedDate()}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login />
        );
    }
};
export default ControlHoraris;
